import { AxiosResponse } from 'axios';

import {
  FlagService,
  StorageOfUniqueServices,
  AxiosWrapperService as axios,
} from '@qality/common-service';

import ErrorHandlingUtils from './ErrorHandlingUtils';

const addTestCases = async (
  testCases: number | number[],
  testCycleId: number
): Promise<AxiosResponse> => {
  const url =
    StorageOfUniqueServices.get('WindowOriginService').origin +
    StorageOfUniqueServices.get('APIConstants').URL_TEST_CYCLES +
    `/${testCycleId}/testCycleAssignments`;

  const requestData = {
    testCasesIds: Array.isArray(testCases) ? testCases : [testCases],
  };

  return axios.post(url, requestData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export default {
  addTestCases,
  async addToCycle(
    testCases: number | number[],
    testCycleId: number
  ): Promise<AxiosResponse | boolean> {
    return await addTestCases(testCases, testCycleId)
      .then((res) => {
        if (res.status === 200) {
          FlagService.createSuccessFlag(
            'Success',
            'The test case was added successfully.'
          );
        }
        return res;
      })
      .catch((err) => {
        ErrorHandlingUtils.handleError(
          err,
          'There was a problem while adding the test case.'
        );
        return false;
      });
  },
};
